 
 import "../../pages/error/error.css"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
 import PaymentSuccessfullImg from "../../assets/images/payment_success_bg.png";

const OrderSuccessfull = () =>{
    
    return(
        <>
         <Header />

         <div className="container-fluid">
            <div className="container">
            <div className="row">
                <div className="col-lg-4 mt_15 offset-md-4">
                    <div className="card_common2 pb_20 mt_30">
                    <div class="error_box"  style={{ height: "60vh" }}>
                    <div class="error_box_in pt_30">
                    <img src={PaymentSuccessfullImg} alt="ps" className="img-fluid" />
                    <div className="pt_20">
                        <h4  className="color_green">Thank You!</h4>
                       <h6 className="color_green">Payment Done Successfully!</h6>
                    </div>
                    <div className="mt_30 pt_10 pb_30 d_flex align_center justify_sp_center">
                    <Link to="/" class="saveForm">Continue Shopping <ArrowForwardIcon /> </Link>
                    </div>
                    </div>
                    </div> 
                </div>
               </div>
               </div>
             </div>
    
      </div>
    
         <Subscribe /> 
       <Footer />
      </>
    )
}

export default OrderSuccessfull;